<template>
    <div>
        <v-text-field label="メーカーコード"
                      v-bind:value="value"
                      v-on:input="(x) => $emit('input', x)"
                      @blur="onBlur"
                      @keydown.enter="onEnter"
                      clearable
                      maxlength="5">
            <template v-slot:append>
                <span class="mx-2 my-code-name" v-if="selected_item != null">{{ selected_item.manufacturer_name }}</span>
                <v-btn icon color="primary darken-3" style="text-align:center;" small
                       v-on:click="dialog = !dialog">
                    <v-icon>mdi-menu</v-icon>
                </v-btn>

            </template>

        </v-text-field>
        <v-dialog v-model="dialog" max-width="1000px">
            <v-card>
                <v-card-title class="headline">メーカー一覧</v-card-title>
                <v-card-text>
                    <v-container>
                        <v-text-field label="メーカー名(あいまい)" v-model="search.manufacturer_name" clearable></v-text-field>

                        <v-row>
                            <v-col></v-col>
                            <v-col cols="auto">
                                <span>
                                    対象件数 {{manufacturer_list.length}}件
                                </span>
                                <v-btn class="mx-2" color="primary darken-3" dark v-on:click="onSearch">検索</v-btn>
                                <v-btn class="mx-2" color="primary darken-3" dark v-on:click="dialog = false">閉じる</v-btn>
                            </v-col>
                        </v-row>
                        <v-simple-table dense height="500px">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left"></th>
                                        <th class="text-left">メーカーコード</th>
                                        <th class="text-left">メーカー名</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in manufacturer_list" :key="item.manufacturer_code">
                                        <td><v-btn class="mx-2" color="primary darken-3" dark v-on:click="onSelectRow(item)">選択</v-btn></td>
                                        <td>{{ item.manufacturer_code }}</td>
                                        <td>{{ item.manufacturer_name }}</td>
                                    </tr>
                                </tbody>

                            </template>

                        </v-simple-table>
                    </v-container>
                </v-card-text>
            </v-card>

        </v-dialog>
    </div>
</template>
<script>


    export default {
        props: ['value'],
        watch: {
            value: function (val) {
                if (val !== this.selected_item.manufacturer_code) {
                    this.selected_item = null;
                }
            }
        },
        data: () => ({
            dialog: false,
            search: {
                manufacturer_name: ""

            },
            manufacturer_list: [],
            selected_item: null,
        }),
        methods: {
            onSelectRow(item) {
                this.dialog = false;
                this.selected_item = item;
                this.$emit('input', item.manufacturer_code);
            },
            async onEnter(e) {
                if (e.keyCode !== 13) return;

                this.value = this.value.trim();
                await this.getProductItem();
            },
            async onBlur() {
                this.value = this.value.trim();
                await this.getProductItem();
            },
            async getProductItem() {
                this.search.manufacturer_name = "";
                await this.onSearch();
                for (var i in this.manufacturer_list) {
                    var item = this.manufacturer_list[i];
                    if (item.manufacturer_code == this.value) {
                        this.selected_item = item;
                        this.$emit('input', item.manufacturer_code);
                        break;
                    }
                }
            },
            async onSearch() {
                try {
                    var params = new URLSearchParams();
                    params.append('param', JSON.stringify(this.search));

                    let res = await this.axios_post('/api/CommonComponents/ManufacturerSearch', params);
                    console.log(res.data);
                    if (res.data.status !== "OK") {
                        this.msg_error_dialog(res.data.messages);
                        return;
                    }
                    this.manufacturer_list = res.data.manufacturer_list;

                } catch (err) {
                    this.msg_error_dialog(err);
                }

            }
        }

    }
</script>

<style>
    .my-code-name {
        padding: 6px 0 8px;
    }
</style>

